import { getMy3DModelByImageSearchListApi, getProductByImageSearchListApi } from '../api/products';
import { MODEL_TYPES } from '../constants/constants';
import {
  paginatedProductActions,
  paginatedProductSelector,
} from '../redux/slicers/admin/paginatedProductSlicer';
import { useDataList, useThumbnailCardDataList } from './useDataList';

export const usePropSearchByImage = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort,
  useGlobalSearch,
  defaultCreatedBy,
  modelType,
  useDataHook = false,
  ...rest
} = {}) => {

  const useHook = useDataHook ? useDataList : useThumbnailCardDataList;

  const data = useHook({
    selector: paginatedProductSelector,
    resetAction: paginatedProductActions.resetList,
    getAction:
      modelType === MODEL_TYPES.THREEDMODELS
        ? getMy3DModelByImageSearchListApi
        : getProductByImageSearchListApi,
    requestParams,
    filterByKey,
    defaultSort,
    useGlobalFilter: true,
    defaultBrands,
    useGlobalSearch,
    defaultCreatedBy,
    modelType,
    ...rest,
  });

  return data;
};
